<div class="bg-surface overflow-hidden shadow shadow-gray-200/50 dark:shadow-zinc-900/50 sm:rounded-lg mb-8 relative">
  <div class="px-4 py-5 sm:p-6">
    <ng-content select="app-card-content"></ng-content>
  </div>
</div>
